import {
  Brush,
  Home,
  Inbox,
  MicVocal,
  Settings,
  ShieldCheck,
  Sparkles,
  UserCog,
  UserPlus,
  Video
} from 'lucide-vue-next';

export const parentNavigation = [
  { key: 'family', label: 'Familie', icon: Home },
  { key: 'approvals', label: 'Freigaben', icon: ShieldCheck },
  { key: 'friends', label: 'Freunde', icon: UserPlus },
  { key: 'settings', label: 'Zeit', icon: Settings }
] as const;

export const childActions = [
  { key: 'drawing', label: 'Malen', icon: Brush, tone: 'bg-rose-100 text-rose-800' },
  { key: 'audio', label: 'Stimme', icon: MicVocal, tone: 'bg-sky-100 text-sky-800' },
  { key: 'video', label: 'Video', icon: Video, tone: 'bg-emerald-100 text-emerald-800' },
  { key: 'play', label: 'Spielen?', icon: Sparkles, tone: 'bg-amber-100 text-amber-800' },
  { key: 'mailbox', label: 'Briefe', icon: Inbox, tone: 'bg-violet-100 text-violet-800' },
  { key: 'parent', label: 'Eltern', icon: UserCog, tone: 'bg-slate-100 text-slate-800' }
] as const;
